module.exports = __webpack_public_path__ + "img/44.ee39714a.jpg";